export const numberGreaterThan = (param) => (value) => value > param;
export const numberGreaterThanOrEqual = (param) => (value) => value >= param;
